var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("static-loading-indicator-icon", { attrs: { "with-card": true } }),
      _vm._v(" "),
      !_vm.$store.getters.isExecutingRequest
        ? _c("div", { staticClass: "card shadow-sm" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("pages.subscription.cancel_subscription")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("pages.subscription.cancel.are_you_sure", {
                      date: _vm.$date(_vm.willBeRenewedAt).format("DD.MM.YYYY")
                    })
                  )
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-danger cursor-pointer",
                    on: { click: _vm.cancelSubscription }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("pages.subscription.cancel.yes_cancel")) +
                        "\n                "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }